// src/oura/lib/quotePdf.ts
//
// The text of a signed quote PDF, read in the browser. The PDF reader loads
// only when a PDF is chosen, so no other screen pays for it.

import { readQuoteText, type QuoteFromText } from "./quoteText";

/** Every page's text, 1 line per line of the page. Throws when the file is not a readable PDF. */
export async function pdfText(file: File): Promise<string> {
    const pdfjs = await import("pdfjs-dist");
    const worker = await import("pdfjs-dist/build/pdf.worker.min.mjs?url");
    pdfjs.GlobalWorkerOptions.workerSrc = worker.default;
    const doc = await pdfjs.getDocument({ data: new Uint8Array(await file.arrayBuffer()) }).promise;
    const pages: string[] = [];
    for (let n = 1; n <= doc.numPages; n++) {
        const page = await doc.getPage(n);
        const content = await page.getTextContent();
        let text = "";
        for (const item of content.items) {
            if (!("str" in item)) continue;
            text += item.str + (item.hasEOL ? "\n" : "");
        }
        pages.push(text);
    }
    await doc.destroy();
    return pages.join("\n");
}

export async function readQuotePdf(file: File): Promise<QuoteFromText> {
    return readQuoteText(await pdfText(file));
}
